<template>
  <div>扫码进入</div>
</template>

<script>
export default {
  name: 'LuckRegist',
  data() {
    return {
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/luck-play/regist.vue